<template>
  <div class="container">
    <bonus-title initial-tab-value="history" />
    <div class="t m-tx4">{{ description }}</div>
    <bonus-events-table :points-config="pointsConfig" class="m-tx4" />
  </div>
</template>

<script setup>
  import { inject } from 'vue';

  const $i18n = inject('$i18n');

  const props = defineProps({
    pointsConfig: { type: Object, required: true },
  });

  const description = `View a complete log of all bonus ${$i18n.t('shoutouts.point', { count: 2 })} awarded to your team. `
    + 'Track past events, verify amounts, and see who has been recognized.';
</script>
